<template lang="pug">
  .header
    auth-modal(
      v-if="showAuthModal"
      @close="showAuthModal = false"
    )
    burger-menu(
      :user-data="userData"
      :lang="lang"
      v-if="showBurgerMenu"
      @close="toggleBurgerMenu"
      :class="setAnimationOnBurgerMenu"
      @setShowAuthModal="setShowAuthModal"
    )
    .header__logo
      router-link(to="/")
        img.logo-main(
          v-if="logoWhite && lang === 'RU'"
          src="@/assets/images/logo/main-page-logo.svg"
        )
        img.logo-main(
          v-else-if="logoWhite && lang === 'TAT'"
          src="@/assets/images/logo/main-page-logo-tat.svg"
        )
        img.logo-main(
          v-else-if="!logoWhite && lang === 'RU'"
          src="@/assets/images/logo/logo-color.svg"
        )
        img.logo-main(
          v-else-if="!logoWhite && lang === 'TAT'"
          src="@/assets/images/logo/logo-color-tat.svg"
        )
        img.logo-adaptive(
          v-if="logoWhite"
          src="@/assets/images/logo/main-page-logo-adaptive.svg"
        )
        img.logo-adaptive(
          v-else=""
          src="@/assets/images/logo/logo-color-adaptive.svg"
        )
    .header__nav
      main-nav(
        :user-data="userData"
        @setShowAuthModal="setShowAuthModal"
      )
    //- .header__lang
    //-   lang-select(
    //-     :lang="lang"
    //-   )
    .header__burger
      button.burger.js-burger(
        @click="toggleBurgerMenu($event)"
      )
</template>
<script>
import {mapState} from "vuex";
import AuthModal from "@/components/modals/AuthModal.vue";
import UserDropdown from "./components/UserDropdown";
import LangDropdown from "./components/LangDropdown";
import BurgerMenu from "./components/BurgerMenu";
import MainNav from "./components/Nav";
import LangSelect from "./components/LangSelect";

export default {
  name: "Header",
  props: {
    logoWhite: {
      type: Boolean,
      default: false
    }
  },
  components: {
    LangSelect,
    BurgerMenu,
    UserDropdown,
    LangDropdown,
    AuthModal,
    MainNav
  },
  data() {
    return {
      showAuthModal: false,
      showBurgerMenu: false,
      hideBurgerMenu: false
    };
  },
  computed: {
    ...mapState(["userData", "lang", "translation"]),
    registration_token() {
      return this.$route.query.registration_token;
    },
    reset_password_token() {
      return this.$route.query.reset_password_token;
    },
    open_sign_in() {
      return this.$route.query.open_modal;
    },
    setAnimationOnBurgerMenu() {
      return !this.hideBurgerMenu
        ? "burger-menu_anim-to-show"
        : "burger-menu_anim-to-hide";
    }
  },
  methods: {
    toggleBurgerMenu() {
      var burger = document.querySelector(".js-burger");
      if (this.hideBurgerMenu) {
        return false;
      }
      burger.classList.toggle("burger_anim-to-active");
      if (!this.showBurgerMenu) {
        burger.classList.remove("burger_anim-to-def");
        this.showBurgerMenu = true;
      } else {
        burger.classList.add("burger_anim-to-def");
        this.hideBurgerMenu = true;
        setTimeout(() => {
          this.showBurgerMenu = false;
          this.hideBurgerMenu = false;
        }, 200);
      }
    },
    setShowAuthModal() {
      this.showAuthModal = true;
    }
  },
  mounted() {
    if (
      this.registration_token ||
      this.reset_password_token ||
      this.open_sign_in
    ) {
      this.showAuthModal = true;
    }
  },
  watch: {
    "$route.query.open_modal"() {
      if (this.$route.query.open_modal) {
        this.showAuthModal = true;
      }
    },
    $route() {
      if (this.showBurgerMenu) {
        this.toggleBurgerMenu();
      }
    }
  }
};
</script>
